import React, { useState, useMemo } from 'react';

const DonutChart = ({
  dashboardList = [],
  centerText = 0,
  valueLabel = '',
  size = 116,
  strokeWidth = 10,
  defaultColors = [ '#FF0000', '#008000', '#808000', '#0066CC', '#FF6600', '#333333', '#99CCFF', '#FF00FF' ] 
  }) => {
  const [strokEval, setStrokEval] = useState(0);

  const renderItem = (item, index) => {
    let strokeWidthProp = strokeWidth;
    let sizeProp = size;
    let halfSize = sizeProp * 0.5;
    let radius = halfSize - strokeWidthProp * 0.5;
    let circumference = 2 * Math.PI * radius;
    let rotateval = `rotate(-90 ${halfSize},${halfSize})`;
    let className = index !== 0 ? 'donutchart-indicator' : 'donutchart-track';

    let trackStyle = {
      strokeWidth: strokeWidthProp,
      stroke: item.color || defaultColors[index],
      strokeDasharray: '0 10',
    };

    if (item && item.value) {
      let value = item.value;
      let strokEvalItem = ((value * circumference) / 100) + strokEval;
      setStrokEval(strokEvalItem);
      let dashval = `${strokEvalItem} ${circumference}`;
      trackStyle.strokeDasharray = dashval;
    }

    return (
      <circle
        key={index}
        r={radius}
        cx={halfSize}
        cy={halfSize}
        transform={rotateval}
        style={trackStyle}
        className={className}
      />
    );
  };

  const records = useMemo(() => dashboardList.map(renderItem), [dashboardList]);

  return (
    <svg width={size} height={size} style={{ marginTop: 10 }}>
      {records.reverse()}
      <text className="donutchart-text" x={size * 0.5} y={size * 0.5} style={{ textAnchor: 'middle' }} >
        <tspan className="donutchart-text-val">{centerText}</tspan>
        <tspan className="donutchart-text-label" x={size * 0.5} y={size * 0.5 + 15}> {valueLabel} </tspan>
      </text>
    </svg>
  );
};

export default DonutChart;
